import { useEffect } from "react";
import api from "@/lib/api";
import { readCache } from "@/lib/offline";

const EVERY = 2 * 60 * 1000;

// Envoie la position du conducteur toutes les 2 minutes pendant une tournée « En tournée »
export default function useGpsTracker(role) {
  useEffect(() => {
    if (role !== "conducteur_vendeur" || !navigator.geolocation) return undefined;
    const send = () => {
      const t = readCache("/itinerant/my-tour")?.tour;
      if (!t || t.statut !== "En tournée" || !navigator.onLine) return;
      navigator.geolocation.getCurrentPosition(
        (p) => api.post(`/itinerant/tournees/${t.id}/position`, { lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }).catch(() => {}),
        () => {}, { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 });
    };
    const first = setTimeout(send, 3000);
    const iv = setInterval(send, EVERY);
    return () => { clearTimeout(first); clearInterval(iv); };
  }, [role]);
}
